module.exports = __webpack_public_path__ + "img/23.c5d81c78.png";